import React from 'react'

const UserGroup = () => {
  return (
    <>
      <div><span className='me-2'><i className="bi bi-person-fill h5" /></span>UserGroup</div>
      <div className='row mt-3'>
        <div className='col-lg-4 col-md-5'>
          <div className='card mb-3'>
            <div className='card-header'>Search</div>
            <div className='card-body '>
              <div class="row mb-3">
                <label for="inputText" className="col-md-3 col-sm-3 col-form-label pe-0">User:</label>
                <div class=" col-md-9 col-sm-9">
                  <input type="text" className="form-control" />
                </div>
              </div>
              <div class="row mb-3">
                <label for="inputText" className=" col-md-3 col-sm-3 col-form-label pe-0">Group:</label>
                <div class=" col-md-9 col-sm-9">
                  <input type="text" className="form-control" />
                </div>
              </div>
              <div className='text-center'>
                <a href='#' className='btn btn-primary'>Search</a>
              </div>
            </div>
          </div>
        </div>
        <div className='col-lg-8 col-md-7'>
          <div className='card mb-3'>
            <div className='card-header'>Latest 10 users created</div>
            <div className='table-responsive'>
              <table className="table table-hover table-nowrap mb-0">
                <tbody>
                  <tr>
                    <td><span className='me-2'><img alt="" src="https://images.unsplash.com/photo-1502823403499-6ccfcf4fb453?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=3&w=256&h=256&q=80" className="avatar-sm rounded-circle me-2"/></span>Brandon Jacob</td>
                    <td>Designer</td>
                    <td>28</td>
                    <td>2016-05-25</td>
                  </tr>
                  <tr>
                    <td><span className='me-2'><img alt="" src="https://images.unsplash.com/photo-1502823403499-6ccfcf4fb453?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=3&w=256&h=256&q=80" className="avatar-sm rounded-circle me-2"/></span>Bridie Kessler</td>
                    <td>Developer</td>
                    <td>35</td>
                    <td>2014-12-05</td>
                  </tr>
                  <tr>
                    <td><span className='me-2'><img alt="" src="https://images.unsplash.com/photo-1502823403499-6ccfcf4fb453?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=3&w=256&h=256&q=80" className="avatar-sm rounded-circle me-2"/></span>Ashleigh Langosh</td>
                    <td>Finance</td>
                    <td>45</td>
                    <td>2011-08-12</td>
                  </tr>
                  <tr>
                    <td><span className='me-2'><img alt="" src="https://images.unsplash.com/photo-1502823403499-6ccfcf4fb453?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=3&w=256&h=256&q=80" className="avatar-sm rounded-circle me-2"/></span>Angus Grady</td>
                    <td>HR</td>
                    <td>34</td>
                    <td>2012-06-11</td>
                  </tr>
                  <tr>
                    <td><span className='me-2'><img alt="" src="https://images.unsplash.com/photo-1502823403499-6ccfcf4fb453?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=3&w=256&h=256&q=80" className="avatar-sm rounded-circle me-2"/></span>Raheem Lehner</td>
                    <td>Dynamic Division Officer</td>
                    <td>47</td>
                    <td>2011-04-19</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className='card mb-3'>
            <div className='card-header'>Latest 5 groups created</div>
            <div className='table-responsive'>
              <table className="table table-hover table-nowrap mb-0">
                <tbody>
                  <tr>
                    <td><span className='me-2'><i className=" bi bi-people-fill h5 avatar-sm rounded-circle me-2"></i></span>Brandon Jacob</td>
                    <td>Designer</td>
                    <td>28</td>
                    <td>2016-05-25</td>
                  </tr>
                  <tr>
                    <td><span className='me-2'><i className=" bi bi-people-fill h5 avatar-sm rounded-circle me-2"></i></span>Bridie Kessler</td>
                    <td>Developer</td>
                    <td>35</td>
                    <td>2014-12-05</td>
                  </tr>
                  <tr>
                    <td><span className='me-2'><i className=" bi bi-people-fill h5 avatar-sm rounded-circle me-2"></i></span>Ashleigh Langosh</td>
                    <td>Finance</td>
                    <td>45</td>
                    <td>2011-08-12</td>
                  </tr>
                  <tr>
                    <td><span className='me-2'><i className=" bi bi-people-fill h5 avatar-sm rounded-circle me-2"></i></span>Angus Grady</td>
                    <td>HR</td>
                    <td>34</td>
                    <td>2012-06-11</td>
                  </tr>
                  <tr>
                    <td><span className='me-2'><i className=" bi bi-people-fill h5 avatar-sm rounded-circle me-2"></i></span>Raheem Lehner</td>
                    <td>Dynamic Division Officer</td>
                    <td>47</td>
                    <td>2011-04-19</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default UserGroup